export default "__VITE_ASSET__fddfe1ad__"